import { render, staticRenderFns } from "./ImpCotizacionesPage.vue?vue&type=template&id=3f661902"
import script from "./ImpCotizacionesPage.vue?vue&type=script&lang=js"
export * from "./ImpCotizacionesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports